/**
 * ISJ — Ocultar Add to Cart + cantidad SOLO en productos con tag "Pendant".
 * Boost re-arma la grilla en el navegador e ignora la condicion del theme, y el
 * theme usa InstantClick (navegacion AJAX). Este script vive en <head> (persiste),
 * observa el DOM y se re-ejecuta en cada navegacion. Por cada boton de compra
 * consulta /products/{handle}.js y, si el producto es Pendant, oculta unicamente
 * el widget de compra de ESE producto (nunca un contenedor).
 */
(function () {
  var TAG = 'pendant';
  var cache = {}; // handle -> Promise<bool>

  function isPendant(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.tags) return false;
        return p.tags.some(function (t) { return String(t).trim().toLowerCase() === TAG; });
      })
      .catch(function () { return false; });
    return cache[handle];
  }

  function handleFrom(scope) {
    var a = scope.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var part = (a.getAttribute('href') || '').split('/products/')[1];
    if (!part) return null;
    return part.split('?')[0].split('#')[0].split('/')[0];
  }

  function hide(el) { if (el) el.style.setProperty('display', 'none', 'important'); }

  function run() {
    var btns = document.querySelectorAll('.add_to_cart, .add_custom_cart, button[name="add"]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.dataset.isjDone) continue;

      var card = btn.closest('form.product_form_custom') ||
                 btn.closest('.thumbnail, .boost-pfs-filter-product-item');
      if (!card) { btn.dataset.isjDone = '1'; continue; } // boton principal de PDP u otro: no tocar

      var h = handleFrom(card);
      if (!h) continue; // el link puede aun no estar; reintenta en el proximo run
      btn.dataset.isjDone = '1';

      (function (b, c) {
        isPendant(h).then(function (yes) {
          if (!yes) return;
          var wrap = b.closest('.product-add-qty') || b.closest('.qty-cta-wrap');
          if (wrap) { hide(wrap); return; }
          hide(b);
          hide(c.querySelector('.product-add-qty, .qty-cta-wrap, .product-quantity-box, .product-quantity-btn'));
        });
      })(btn, card);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; run(); }, 150);
  }

  var booted = false;
  function boot() {
    run();
    if (!booted) {
      booted = true;
      if (window.MutationObserver) {
        new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
      }
      // InstantClick: re-ejecutar tras cada navegacion AJAX
      if (window.InstantClick && InstantClick.on) {
        InstantClick.on('change', function () { run(); schedule(); });
      }
    }
    setTimeout(run, 800);
    setTimeout(run, 2000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', run);
})();
